<template>
  <!-- 25.6.5 合作伙伴列表 dxm -->
  <div class="partner_list_wrap">
    <div class="partner_list flex flex_wrap">
      <img
        v-for="(item, index) in list"
        :key="index"
        :src="item.image"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.partner_list_wrap {
  padding: 40px 0 100px;
  background: url("../assets/imgs/p_bg.png") no-repeat center -50px;
  background-size: 100% 120%;
  .partner_list {
    img {
      width: 190px;
      height: 86px;
      margin-right: 28px;
      margin-bottom: 20px;
      background: #fff;
      &:nth-child(6n) {
        margin-right: 0;
      }
    }
  }
}
@media only screen and (max-width: 1280px) {
  .partner_list_wrap {
    .partner_list {
      img {
        width: calc((100% - 100px) / 6);
        height: auto;
        margin-right: 20px;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .partner_list_wrap {
    margin: 20px 0 30px;
    padding: 20px 0 50px;
    background: #fff url("../assets/imgs/p_bg.png") no-repeat center -50px;
    background-size: 100% 120%;
    .partner_list {
      img {
        width: 2rem;
        height: 0.96rem;
        margin-right: 0.29rem;
        margin-bottom: 0.35rem;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>